import React from 'react';
import nt_main from '../img/nt_main.jpg';
const GeneralTestimonials = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div class="content-wrapper">  
            <div>
            Clients consistently describe significant shifts in clarity, confidence,
             and sustainable performance. 
             <br /><br />
             Many report a deeper understanding 
             of the behavioural patterns that shaped their decisions, relationships, 
            and responses to pressure, often noticing measurable change within a few sessions. 
            </div>
            <div>
            "I finally understood the pattern that had been limiting me for years."
            <br /><br />
            <b>Anonymous</b>
            </div>
            <div>
            "Ive worked with coaches before, but this went deeper and created real change.""
            <br /><br />
            <b>Anonymous</b>
            </div>
             <div>
             "I communicate differently now—more clearly, more calmly, and with far more confidence.”
            <br /><br />
            <b>Anonymous</b>
            </div>
             <div>
             “For the first time, I can identify my limiting behaviors and I have the tools to address them.”
            <br /><br />
            <b>52 Year Old Male</b>
            </div>
           </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div class="content-wrapper">  
            <div>
            Клиенты постоянно описывают значительные сдвиги в ясности, уверенности
             и устойчивой производительности. 
             <br /><br />
             Многие сообщают о более глубоком понимании 
             поведенческих паттернов, которые определяли их решения, отношения 
            и реакции на давление, часто замечая измеримые изменения в течение нескольких сеансов. 
            </div>
            <div>
            "Я наконец понял паттерн, который ограничивал меня годами."
            <br /><br />
            <b>Анонимно</b>
            </div>
            <div>
            "Я работал с коучами раньше, но это было глубже и создало реальные изменения."
            <br /><br />
            <b>Анонимно</b>
            </div>
             <div>
             "Теперь я общаюсь иначе — яснее, спокойнее и с гораздо большей уверенностью."
            <br /><br />
            <b>Анонимно</b>
            </div>
             <div>
             "Впервые я могу определить свое ограничивающее поведение и у меня есть инструменты для его решения."
            <br /><br />
            <b>52-летний мужчина</b>
            </div>
           </div>
        );
    }
}
export default GeneralTestimonials;
